export const getDefaultFloatingOptions = ({
  isNested
}) => ({
  mainAxis: isNested ? 0 : 4,
  alignmentAxis: isNested ? -4 : 0
});